// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2yAqL","title":"ClientReferral_title__2fblz","itemText":"ClientReferral_itemText__1MJEl"};